import { defineMessages } from 'react-intl';

// Main route
const groupsScope = 't.page.store';

// Global scope
const globalScope = 't.global';

// Navigation
const navigationScope = 't.component.PortalAppNavigation';

// Global errors
const globalErrorsScope = 't.global.error';

export default defineMessages({
	successfullyDelete: {
		id: `${groupsScope}.successfullyDelete`,
		defaultMessage: 'Negozio eliminato con successo',
	},
	failureDelete: {
		id: `${groupsScope}.failureDelete`,
		defaultMessage: 'Eliminazione negozio fallita',
	},
	deleteSubtitle: {
		id: `${groupsScope}.deleteSubtitle`,
		defaultMessage: 'del negozio',
	},
	detailTitle: {
		id: `${groupsScope}.detailTitle`,
		defaultMessage: 'Dettaglio negozio',
	},
	storeEditing: {
		id: `${groupsScope}.storeEditing`,
		defaultMessage: 'Modifica negozio',
	},
	storeCreation: {
		id: `${groupsScope}.storeCreation`,
		defaultMessage: 'Crea negozio',
	},
	newStoreTitle: {
		id: `${groupsScope}.newStoreTitle`,
		defaultMessage: 'Inserisci i dati del negozio',
	},
	storeCreatedSuccessfully: {
		id: `${groupsScope}.storeCreatedSuccessfully`,
		defaultMessage: 'Negozio creato con successo',
	},
	storeNotCreatedSuccessfully: {
		id: `${groupsScope}.storeNotCreatedSuccessfully`,
		defaultMessage: 'Creazione negozio fallita',
	},
	storeUpdatedSuccessfully: {
		id: `${groupsScope}.storeUpdatedSuccessfully`,
		defaultMessage: 'Negozio modificato con successo',
	},
	storeUpdatedNotSuccessfully: {
		id: `${groupsScope}.storeUpdatedNotSuccessfully`,
		defaultMessage: 'Modifica negozio fallita',
	},
	goBackModalButton: {
		id: `${groupsScope}.goBackModalButton`,
		defaultMessage: "Torna all'elenco negozi",
	},
	id: {
		id: `${groupsScope}.id`,
		defaultMessage: 'Id',
	},
	storeData: {
		id: `${groupsScope}.storeData`,
		defaultMessage: 'Dati negozio',
	},

	// Navigation Scope
	pageTitle: {
		id: `${navigationScope}.store.storeList`,
		defaultMessage: 'Elenco Negozi',
	},
	newGroup: {
		id: `${navigationScope}.store.storeManagement`,
		defaultMessage: 'Crea Negozio',
	},

	// Global Scope
	name: {
		id: `${globalScope}.name`,
		defaultMessage: 'Nome',
	},
	merchant: {
		id: `${globalScope}.merchant`,
		defaultMessage: 'Merchant',
	},
	group: {
		id: `${globalScope}.group`,
		defaultMessage: 'Gruppo',
	},
	creationDate: {
		id: `${globalScope}.creationDate`,
		defaultMessage: 'Data creazione',
	},
	abortLabelButton: {
		id: `${globalScope}.abort`,
		defaultMessage: 'Annulla',
	},
	createLabelButton: {
		id: `${globalScope}.create`,
		defaultMessage: 'Crea',
	},
	confirmLabelButton: {
		id: `${globalScope}.confirm`,
		defaultMessage: 'Conferma',
	},
	saveLabelButton: {
		id: `${globalScope}.save`,
		defaultMessage: 'Salva',
	},
	emptyString: {
		id: `${globalScope}.emptyString`,
		defaultMessage: ' ',
	},
	edit: {
		id: `${globalScope}.edit`,
		defaultMessage: 'Modifica',
	},
	warning: {
		id: `${globalScope}.warning`,
		defaultMessage: 'Attenzione',
	},
	subtitleDelete: {
		id: `${globalScope}.subtitleDelete`,
		defaultMessage: 'Sei sicuro di voler procedere alla cancellazione {element}?',
	},
	country: {
		id: `${globalScope}.country`,
		defaultMessage: '"Nazione"',
	},
	county: {
		id: `${globalScope}.county`,
		defaultMessage: 'Provincia',
	},
	address: {
		id: `${globalScope}.address`,
		defaultMessage: 'Indirizzo',
	},
	cap: {
		id: `${globalScope}.cap`,
		defaultMessage: 'Cap',
	},
	municipality: {
		id: `${globalScope}.municipality`,
		defaultMessage: 'Comune',
	},
	lastUpdateDate: {
		id: `${globalScope}.lastUpdateDate`,
		defaultMessage: 'Data ultimo aggiornamento',
	},

	//Errors Global Scope
	invalidDate: {
		id: `${globalErrorsScope}.invalidDate`,
		defaultMessage: 'Data non valida',
	},
	theSecondDateIsMinorThanFirst: {
		id: `${globalErrorsScope}.theSecondDateIsMinorThanFirst`,
		defaultMessage: 'Data di fine troppo piccola',
	},
	fillFirstDateToContinueValidation: {
		id: `${globalErrorsScope}.fillFirstDateToContinueValidation`,
		defaultMessage: "Data d'inizio mancante",
	},
	fieldRequested: {
		id: `${globalErrorsScope}.fieldRequested`,
		defaultMessage: 'Campo obbligatorio',
	},
	maxLength: {
		id: `${globalErrorsScope}.maxLength`,
		defaultMessage: 'Superata lunghezza massima',
	},
});
